import get from 'lodash/get';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './DealerAdIframe';
import { getCurrentUser, getPublicSession } from '../publicSession/selectors';

export type StateProps = Pick<
  Props,
  'userGuid' | 'biClientId' | 'biClientIdSigned'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state
): StateProps => ({
  userGuid: get(getCurrentUser(state), 'useridUuid'),
  biClientId: get(getPublicSession(state), 'biClientId'),
  biClientIdSigned: get(getPublicSession(state), 'biClientIdSigned'),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
